// src/router/index.js
import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";

Vue.use(VueRouter);

/* — Evita errores por navegaciones duplicadas / redirecciones — */
const origPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(loc, onRes, onRej) {
  if (onRes || onRej) return origPush.call(this, loc, onRes, onRej);
  return origPush.call(this, loc).catch((err) => {
    const msg = String(err && err.message);
    if (msg.includes("Avoided redundant navigation") || msg.includes("Redirected")) return err;
    if (err && err.name === "NavigationDuplicated") return err;
    throw err;
  });
};

const origReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(loc, onRes, onRej) {
  if (onRes || onRej) return origReplace.call(this, loc, onRes, onRej);
  return origReplace.call(this, loc).catch((err) => {
    const msg = String(err && err.message);
    if (msg.includes("Avoided redundant navigation") || msg.includes("Redirected")) return err;
    if (err && err.name === "NavigationDuplicated") return err;
    throw err;
  });
};

/* — Router — */
const router = new VueRouter({
  mode: "hash",
  base: "/",
  routes,
  linkExactActiveClass: "active",
  scrollBehavior: (to) => (to.hash ? { selector: to.hash } : { x: 0, y: 0 }),
});

export default router;